export const data = [];

// Change to state.....cleanup
export const resetData = () => {
    data.length = 0;
};
